import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';

import { HyperSpaceStackedColumnChartWidgetOptions } from './types';
import { observable } from 'mobx';
import {
    BaseXYAxisChartOptions,
    LegendOptions,
    MetaInfoOptions,
} from '@sprinklr/stories/hyperspaceWidgets/types';
import { LegendOptionsImpl } from '../options';

export class HyperSpaceStackedColumnChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceStackedColumnChartWidgetOptions {
    @observable labels = { enabled: false, inset: false };
    @observable barHeight = 90;
    @observable includeMetrics = false;
    @observable zeroFill = true;
    @observable baseXYChartOptions: BaseXYAxisChartOptions = {
        grid: {
            enabled: false,
        },
        xAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
        yAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
    };
    @observable metaInfoOptions: HyperSpaceStackedColumnChartWidgetOptions['metaInfoOptions'] = {
        color: {
            enabled: false,
            type: 'fill',
        },
    };
    @observable legend: LegendOptions = new LegendOptionsImpl();
    @observable columnWidth = 90;
}
